import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { validatePinPassword, resetPinPassword } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import DialogInput from 'screens/components/advanced/DialogInput';
import PinInput from 'screens/components/basic/PinInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class OpenDrawerPinDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pin: '',
            dialogStatus: this.props.dialogOpen,
            isValidPin: false,
            isDrawerOpen: false
        };
        this.validatePin = this.validatePin.bind(this);
        this.resetPin = this.resetPin.bind(this);
    }

    deletePrevPinNumber() {
        if (this.state.pin.length !== 0) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    pin: prevState.pin.slice(0, -1)

                };
            });
        }
    }

    validatePin = () => {
        if (this.props.openDrawerPinCode && this.props.openDrawerPinCode.length === 4) {
            let model = {
                branchId: this.props.branchId,
                pinPassword: this.props.openDrawerPinCode,
                cashFlowId: this.props.cashFlow ? this.props.cashFlow.id : 0
            }
            this.props.validatePinPassword(model);
        }
    }

    componentDidUpdate(prevProps) {
        const { pin } = this.props || {};
        // Check if the pin validity has changed
        if (pin && prevProps.pin && pin.isValidPin !== prevProps.pin.isValidPin) {
            // If the pin is valid, close the dialog
            if (pin.isValidPin) {
                this.props.handleClose();
                this.props.openDrawer();
                this.resetPin();
            }
        }
    }

    resetPin() {
        this.props.clearFormInput('openDrawerPinCode');
        this.props.resetPinPassword();
    }

    render() {
        const { t } = this.props; 

        const p = this.props;

        return (
            <DialogInput
                modal={true}
                open={p.open}
                title={<DialogHeaderWithClose text={t('pos.openDrawerPinDialog.enterPin')} classicClass="posDialogClassic" handleClose={() => p.handleClose()} />}
                style={{
                    width: `50%`
                }}
            >
                <div className="row">
                    <div className="col-lg-12">
                        <PinInput  key={1} name="openDrawerPinCode" label={t('common.pinCode')} type="password" maxLength={4} autoComplete="off" />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-12 text-right">
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label={t('common.confirm')}
                            className="pull-right"
                            primary={true} 
                            onTouchTap={() => this.validatePin()}
                        />
                    </div>
                </div>
            </DialogInput>

        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        pin: state.entity.pin,
        formError: state.form.error,
        openDrawerPinCode: state.form.openDrawerPinCode || "",
        cashFlow: state.entity.cashFlow
    };
}

function mapDispatchToProps(dispatch) {
    return {
        validatePinPassword: (model) => dispatch(validatePinPassword(model)),
        resetPinPassword: () => dispatch(resetPinPassword()),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OpenDrawerPinDialog));